// extracted by mini-css-extract-plugin
export default {"floating-delete-button":"excludeButton_floating-delete-button__S5JlL"};